export default __webpack_public_path__ + "static/Logo-dafe77d4a93d49b92db9d67d129a5a3d.png";